let { TPL_PARAMS, VIDEO_EVENT_URL, systemVar } = require('./../vpadn-sdk-parameters.partial')
const { isSDKiOS } = require('../vpadn-sdk-features.partial')
let { isElement, VponConsole, assets, digitSet, isVponOMIDBridgeExist } = require('./../vpadn-sdk-utils.partial')

class VponVideo {
  constructor(videoContainer, videoConfig) {
    const video_area = typeof videoContainer === 'string' ? document.querySelector(`#${videoContainer}`) : videoContainer;
    if (isElement(video_area)) {
      throw new Error('[VponVideo] video container is not dom object');
    } 
    let config = null;
    try {
      config = JSON.parse(JSON.stringify(videoConfig));
    } catch (err) {
      throw new Error('[VponVideo] video config is invalid');
    }
    const templateSearchParams = new URL(window.location).searchParams;
    const listeners = [];
    let isAdChoiceActive = false;
    let isPlaying = false;
    let isSendTrackingEventArr = [];
    let videoDurationTemp = 0;
    this.eventListener = {};
    const video = document.createElement('video');
    video.setAttribute('aria-label', systemVar.ariaLabel.video_view);

    /**
     * generate icon mute/unmite area
     * @param {String} domname tag name
     * @param {String} iconMuteSrc icon mute source
     * @param {String} iconUnmiteSrc icon unmute source
     * @returns icon area
     */
    function createIconMuteArea(domname, iconMuteSrc, iconUnmiteSrc) {
      var dom = document.createElement(domname);
      dom.style.width = "32px";
      dom.style.height = "32px";
      dom.style.position = "absolute";
      dom.style[config.mutePosition === 'top' ? 'top' : 'bottom'] = "10px";
      dom.style.right = "15px";
      dom.style.display = config.muteHidden ? 'none' : 'block';

      var img1 = document.createElement("img");
      img1.src = iconMuteSrc;
      img1.id = "icon_mute";
      img1.setAttribute('aria-label', systemVar.ariaLabel.mute_icon);
      img1.style.width = "100%";
      img1.style.height = "100%";
      img1.style.display = "none";
      img1.style.position = "absolute";
      img1.style.top = "0px";

      var img2 = document.createElement("img");
      img2.src = iconUnmiteSrc;
      img2.id = "icon_unmute";
      img2.setAttribute('aria-label', systemVar.ariaLabel.unmute_icon);
      img2.style.width = "100%";
      img2.style.height = "100%";
      img2.style.display = "none";
      img2.style.position = "absolute";
      img2.style.top = "0px";
      dom.appendChild(img1);
      dom.appendChild(img2);
      return dom;
    }
    
    const iconmuteArea = createIconMuteArea("div", assets.iconMuteSrc, assets.iconUnmiteSrc);

    this.play = function () {
      if (isAdChoiceActive) {
        return;
      }
      const videoPlay = video.play();
      videoPlay.then(res => {
      }).catch(err => {
        if (err.message.indexOf('denied permission') !== -1) {
          const video_area = typeof videoContainer === 'string' ? document.querySelector(`#${videoContainer}`) : videoContainer;
          video_area.appendChild(playBtnAreaNode);
        }
        console.warn(err);
      });
      customTracking(this.eventListener, 'play');
    };

    this.onPlay = function(callback) {
      if (typeof callback === 'function') {
        video.addEventListener('play', function() {
          callback();
        });
      }
    }

    this.pause = function () {
      video.pause();
      customTracking(this.eventListener, 'pause');
    }

    this.onPause = function(callback) {
      if (typeof callback === 'function') {
        video.addEventListener('pause', function() {
          callback();
        });
      }
    }

    this.resume = function () {
      this.playAtPosition(0);
      this.play();
      customTracking(this.eventListener, 'resume');
    }

    this.mute = function () {
      video.muted = true;
    }

    this.unmute = function () {
      video.muted = false;
    }

    this.isMuted = function () {
      return video.muted;
    }

    this.isPaused = function () {
      return video.paused;
    }

    this.isEnded = function() {
      return video.ended;
    }

    this.playAtPosition = function (sec) {
      video.currentTime = sec;
    }

    this.getDuration = function () {
      return video.duration
    }

    this.getCurrentTime = function () {
      return video.currentTime;
    }

    this.togglePlay = function () {
      const method = video.paused ? 'play' : 'pause';
      this[method]();
    }

    this.toggleMuted = function () {
      const method = video.muted ? 'unmute' : 'mute';
      this[method]();
    }

    this.create = function () {
      bindVideoEvents();
      videoInit(config);
    };

    this.sendLinkTracking = function () {
      sendQuartileTracking(trackingUrl.link)
    }

    this.sendReplayTracking = function () {
      sendQuartileTracking(trackingUrl.replay)
    }

    this.onTimeupdate = function (callback) {
      if (typeof callback != 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return;
      }
      video.addEventListener("timeupdate", function() {
        callback(video.currentTime);
      });
    }

    this.onPlayStatusChanged = function (callback) {
      if (typeof callback != 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return;
      }
      video.addEventListener("play", function () { callback(video.paused ? 'pause' : 'play') });
      video.addEventListener("pause", function () { callback(video.paused ? 'pause' : 'play') });
    }

    this.onMuteStatusChanged = function (callback) {
      if (typeof callback != 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return;
      }
      video.addEventListener('volumechange', function () { callback(video.muted ? 'muted' : 'unmuted') });
    }
    this.onMuteIconClick = function (callback) {
      if (typeof callback != 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return;
      }
      mutedcallback = callback;
    }

    this.onCanBePlay = function (callback) {
      if (typeof callback !== 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return
      }
      const onCanBePlayCallback = () => {
        if (isSDKiOS() ? video.readyState >= 1 : video.readyState >= 2) {
          callback();
          video.removeEventListener(isSDKiOS() ? 'loadedmetadata' : 'canplay', onCanBePlayCallback);
        } else {
          VponConsole('warn', `[VponVideo] can not play, readyState is ${video.readyState}`);
        }
      }
      video.addEventListener(isSDKiOS() ? 'loadedmetadata' : 'canplay', onCanBePlayCallback);
    }

    this.onVideoEnded = function (callback) {
      if (typeof callback != 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return;
      }
      video.addEventListener("ended", callback);
    }

    this.onVideoViewershipListener = function (event, callback) {
      if (typeof callback != 'function') {
        VponConsole('warn', '[VponVideo] please input callback function');
        return;
      }

      switch (event) {
        case 'play':
        case 'pause':
        case 'resume':
        case 'quartileTracking':
          this.eventListener[event] = callback;
          break;
        default:
          VponConsole('warn', '[VponVideo] not support event listener');
      }
    }

    this.changeStyle = (obj) => {
      Object.entries(obj).forEach(target => {
        let selectedTarget = null;

        switch (target[0]) {
          case 'mute':
            selectedTarget = iconmuteArea;
            break;
          case 'countdown':
            selectedTarget = videoTimeSpan;
            break;
          case 'replay':
              selectedTarget = replayButton;
            break;
        }

        if (selectedTarget) {
          Object.entries(target[1]).forEach(item => {
            switch (item[0]) {
              case 'position':
                switch (item[1]) {
                  case 'leftTop':
                    selectedTarget.style.top = '10px';
                    selectedTarget.style.bottom = 'auto';
                    selectedTarget.style.left = '15px';
                    selectedTarget.style.right = 'auto';
                    break;
                  case 'rightTop':
                    selectedTarget.style.top = '10px';
                    selectedTarget.style.bottom = 'auto';
                    selectedTarget.style.left = 'auto';
                    selectedTarget.style.right = '15px';
                    break;
                  case 'leftBottom':
                    selectedTarget.style.top = 'auto';
                    selectedTarget.style.bottom = '10px';
                    selectedTarget.style.left = '15px';
                    selectedTarget.style.right = 'auto';
                    break;
                  case 'rightBottom':
                    selectedTarget.style.top = 'auto';
                    selectedTarget.style.bottom = '10px';
                    selectedTarget.style.left = 'auto';
                    selectedTarget.style.right = '15px';
                    break;

                }
                break;
              case 'display':
                selectedTarget.style.display = item[1];
                break;
            }
          });
        }
      });
    }
    
    this.destroy = () => {
      videoDestroy();
    }

    function videoDestroy() {
      const video = video_area.querySelector('video');
      video.src = '';
      video.removeEventListener('timeupdate', handleTimeUpdateFunc);
      video.remove();
    }

    this.triggerVideoStartCallback = listener => {
      if (typeof listener !== 'function') {
        VponConsole('warn', '[VponVideo] args is not a function');
        return
      }
      listeners.push(listener)
    }

    var eventsLister = this.eventListener;

    function bindVideoEvents() {
      video.addEventListener('abort', handleVideoAbort);
      video.addEventListener('canplay', handleVideoCanBePlay);
      video.addEventListener('canplaythrough', handleVideoCanPlayThrogh);
      video.addEventListener('durationchange', handleVideoDurationChange);
      video.addEventListener('emptied', handleVideoEmptied);
      video.addEventListener('ended', handleVideoEnded);
      video.addEventListener('error', handleVideoError);
      video.addEventListener('loadeddata', handleVideoLoadeddata);
      video.addEventListener('loadedmetadata', handleVideoLoadedmetadata);
      video.addEventListener('loadstart', handleVideoLoadstart);
      video.addEventListener('pause', handleVideoPause);
      video.addEventListener('play', handleVideoPlay);
      video.addEventListener('playing', handleVideoPlaying);
      video.addEventListener('progress', handleVideoProgress);
      video.addEventListener('ratechange', handleVideoRatechange);
      video.addEventListener('seeked', handleVideoSeeked);
      video.addEventListener('seeking', handleVideoSeeking);
      video.addEventListener('stalled', handleVideoStalled);
      video.addEventListener('suspend', handleVideoSuspend);
      video.addEventListener('timeupdate', handleVideoTimeupdate);
      video.addEventListener('volumechange', handleVideoVolumechange);
      video.addEventListener('waiting', handleVideoWaiting);
  }

  function handleVideoAbort() {
    VponConsole('warn', '[VponVideo] video was aborted');
    return false;
  }

  function handleVideoCanBePlay() {}
  
  function handleVideoCanPlayThrogh() {}

  function handleVideoDurationChange() {}

  function handleVideoEmptied() {}

  function handleVideoEnded() {
    util.track();
    if (config.loop === true) {
      video.play();
    }
  }

  function handleVideoError() {
    VponConsole('warn', '[VponVideo] video was error');
    return false;
  }

  function handleVideoLoadeddata() {}

  function handleVideoLoadedmetadata() {}

  function handleVideoLoadstart() {}

  function handleVideoPause() {
    if (!video.ended) {
      if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
        VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.pause()');
        window.vponOMIDBridge.videoEvents.pause();
        if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
          VponConsole('log', '[VponVideo] fire omEventOccur.');
          fireOMEventOccur(vponOMIDBridge.deviceType, 'pause', vponOMIDBridge.sessionId)
        }
      }
    }

    if (isSendTrackingEventArr.indexOf('videoPause') === -1) {
      isSendTrackingEventArr.push('videoPause');
      sendQuartileTracking(trackingUrl.pause);
    }
  }

  function handleVideoPlay() {
    if (playBtnAreaNode) {
      playBtnAreaNode.remove();
    }

    if (video.currentTime !== 0) {
      if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
        VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.resume()');
        window.vponOMIDBridge.videoEvents.resume();
        if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
          VponConsole('warn', '[VponVideo] fire omEventOccur.');
          fireOMEventOccur(vponOMIDBridge.deviceType, 'resume', vponOMIDBridge.sessionId)
        }
      }
    }

    if (isSendTrackingEventArr.indexOf('videoPlay') === -1) {
      isSendTrackingEventArr.push('videoPlay');
      sendQuartileTracking(trackingUrl.play);
    }
  }

  function handleVideoPlaying() {
    if (video.poster && isSDKiOS()) {
      video.removeAttribute('poster');
    }
  }

  function handleVideoProgress() {}

  function handleVideoRatechange() {}

  function handleVideoSeeked() {}

  function handleVideoSeeking() {}

  function handleVideoStalled() {}

  function handleVideoSuspend() {}

  function handleVideoTimeupdate() {}

  function handleVideoVolumechange() {
    
  }

  function handleVideoWaiting() {}

   // Draw play button area
  function generatePlayBtnArea (poster) {
    const playBtnArea = document.createElement('div');
    playBtnArea.id = 'playBtnDiv';
    playBtnArea.style.width = '100%';
    playBtnArea.style.height = '100%';
    playBtnArea.style.position = 'absolute';
    playBtnArea.style.top = "0px";
    playBtnArea.style.zIndex = '9999';
    // It's current white poster, need to change to black ??
    playBtnArea.style.backgroundImage = poster ? poster : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApsAAAF3AQMAAADQMhJDAAAABlBMVEUAAAAAAAClZ7nPAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADh0lEQVR4nO2YsW7bMBCGqQqwloBaMwhyH8GjBqN+FT2CxgxBrUfTA/QhWHToVmj0EITlHU+kLBm1GGcq/g+JIonmh6N4OtJRCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwB0qOmTDjZabNzdR2Is7nm3vfq290lirVOluXtyH7HuKdE8fz6w1K2lBlx+Tfle1628yQxdXA973+cgnjSpSjI6L+uIG2auvLO1nLUdqJA5Kpzl9hLVc5XPpgb2OLlWaDxKUv1q0cmaoNlVacGwv09Wi1ctMspSP3ZVkIXWzlyidYvE8LVp3LO1TpdfvU7Vo5XHkD0qfb0rXj+UOrAnp2dySFslS1oT0PNyS7pKlrAnp2S1aeaL0egKTpO100vs/HOFTspRjCzlv6DDEmWNp9aB0EHMuUpY9J0tbOuzkwgfYTS+vJFyTLs3eSbo3LO1FUkor58Zh/VLcwexdedeZfaMLn1pVLIWdHFKl52JUuhjPLOVbOpRCX2xbJ/VnW/k5urqn9/4p+gkrQin0j9b5qpNNkf4a1DeljyqnUPyEuYfg1ya3fhGDky7W2Tv8plnR7rGRx7+N2SCDtaO/dGugycYE6R8arjZ+TiRzjKSpSHsnjYvDFn7QcJ8Gnz0yyZ2kacYPklKijsvYFi70+rgVmjuJtJnStBhUKGH1qus/pRlLSSjltAoCGr+8wynVb6RsLCUSkeow1CZKUzYpFAtLKRKp0UWYFAp/ly419KtFKjU6D+kzNaj1PmOztPX34jtJNyXPrnZEG6Qt9d2psPznQUpjrj4m7bT0F1kRhv8Z0sHfK8NKTabnx6TTylSH8kmm5nOkx5DoD0iniZr6vYScpDtdPH1EOgbBB6XUxVBkOuR3ZsKGjUztY1IZtaumZiY1nyJ11XTaU1HsJp5uhebWUBQ6lI4ybilnyZtSUBrKJJJWoXTUcZ2f5VmK9MjSYS49xopcLvZqG6loCqhjE+J7iWHpOEEpUj8/Zr65GaOpjqcpO5+Sf0b+8f2omoYXNkpTVlOXPzWNmFQy5yQkUxufxCFt3XcF+VW5nQ+txovvJq+KtiWFDzNph6LeaEUqh5NaSU99OYh0P9Dpds7W0D8h6B8Pi+8mhbW9zHphk3Z9quSP87Zp+YWHd8I6ngIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwH/FX4Ok7MIGd0maAAAAAElFTkSuQmCC';
    playBtnArea.style.backgroundSize = 'cover';

    const playBtn = document.createElement('img');
    playBtnArea.id = 'playBtn';
    playBtn.src = 'data:image/png;base64,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';
    playBtn.style.position = 'absolute';
    playBtn.style.top = '50%';
    playBtn.style.left = '50%';
    playBtn.style.transform = 'translate(-50%, -50%)';
    playBtn.style.zIndex = '9999';
    
    playBtnArea.appendChild(playBtn);
    playBtnArea.addEventListener('click', function (e) {
      e.stopPropagation();
      playBtnArea.remove();
      video.play();
    });

    this.clickPlayButton = (callback) => {
      playBtnArea.addEventListener('click', function (e) {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    return playBtnArea;
  }


    //--
    var trackingTimes = {}
    var trackingTimesArray = [];
    var OnceArray = [];
    var mutedcallback = "";
    var playBtnAreaNode = generatePlayBtnArea.call(this, config.poster);

    function switchmuteicon(iconmuteArea, h) {
      if (h.muted == true) {
        iconmuteArea.children[0].style.display = "none";
        iconmuteArea.children[1].style.display = "block";
        h.muted = false;
      } else {
        iconmuteArea.children[0].style.display = "block";
        iconmuteArea.children[1].style.display = "none";
        h.muted = true;
      }
    }
    function videoInit(config) {
      if (!config.src) {
        VponConsole('error', '[VponVideo] please input video src');
        return false;
      }
      video.preload = 'metadata';
      video.poster = config.poster ? config.poster : assets.videoPosterSrc;
      video.src = config.src;
      video.loop = false;
      video.muted = true;
      video.autoplay = false;
      video.style.width = '100%'
      video.style.height = '100%'

      //detect ad container hide
      window.addEventListener('message', function(e) {
        if (e.data.event === 'destroy') {
          videoDestroy();
        }

        if (e.data.event === 'adChoiceActive') {
          isAdChoiceActive = true;
          video.pause();
        }

        if (e.data.event === 'adChoiceInactive') {
          isAdChoiceActive = false;
          video.play();
        }
      });

      video.setAttribute("webkit-playsinline", "webkit-playsinline");
      video.setAttribute("playsinline", "playsinline");
      video.setAttribute("x5-playsinlin", "");
      video.setAttribute("x-webkit-airplay", "allow");
      const video_area = typeof videoContainer === 'string' ? document.querySelector(`#${videoContainer}`) : videoContainer;
      video_area.classList.add('omid-element');
      video_area.appendChild(video);
      if (config.showmuted !== false) {
        video_area.appendChild(iconmuteArea);
        iconmuteArea.addEventListener("click", handleIconMuteAreaClick);
        iconmuteArea.children[0].style.display = "block";
      }
    }

    function handleIconMuteAreaClick(e) {
      e.stopPropagation();
      e.preventDefault();
      switchmuteicon(iconmuteArea, video);
      if (OnceArray.indexOf("trackingTimesArray") == -1) {
        sendQuartileTracking(trackingUrl.changemute);
        OnceArray.push("trackingTimesArray");
      }
      if (mutedcallback) {
        mutedcallback();
      }
    }

    function handleTimeUpdateFunc() {
      if (video.poster && isSDKiOS()) {
        video.removeAttribute('poster');
      }
      if (playBtnAreaNode) {
        playBtnAreaNode.remove();
      }
      util.track();
      handleTimeUpdate();
    }
``
    function customTracking(eventListener, event, ret) {
      if (eventListener.hasOwnProperty(event)) {
        const listener = eventListener[event];
        listener(ret);
      }
    }

    const track = function () {
      let videoLeftTime = 0;
      if (!video.duration) {
        videoLeftTime = Math.floor(videoDurationTemp - video.currentTime)
      } else {
        videoLeftTime = Math.floor(video.duration - video.currentTime);
        videoDurationTemp = video.duration
      }
      sendVideoTrackings(eventsLister, videoLeftTime)
    }

    function sendVideoTrackings(eventsLister, videoLeftTime) {
      if (trackingTimesArray.length > 0) {
        trackingTimesArray.filter(function (trackingTimesElement) {
          return videoLeftTime <= trackingTimesElement.time
        }).map(function (missDeliverElement) {
          sendVideoTracking(eventsLister, missDeliverElement.time)
        })

        trackingTimesArray = trackingTimesArray.filter(function (trackingTimesElement) {
          return videoLeftTime > trackingTimesElement.time
        })
      }
    }

    /**
     * Send tracking by trackingUrls.
     * @param {Array} trackingUrls
     */
    function sendQuartileTracking(trackingUrls) {
      if (typeof window.navigator.sendBeacon != "undefined") {
        for (let i in trackingUrls) {
          if (trackingUrls[i]) {
            navigator.sendBeacon(trackingUrls[i] + '&r=' + video.currentTime);
          }
        }
      } else {
        for (let i in trackingUrls) {
          if (trackingUrls[i]) {
            const trackingSender = createTrackingSender();
            trackingSender.src = trackingUrls[i] + '&r=' + video.currentTime;
          }
        }
      }
    }

    function createTrackingSender() {
      const trackingImg = document.createElement('img')
      trackingImg.width = '0px'
      trackingImg.height = '0px'
      trackingImg.style = 'display:none'
      document.body.appendChild(trackingImg)
      return trackingImg
    }

    var util = {
      track: track,
    };

    function getVideoEventUrlByEvnt(event) {
      if (config.track !== undefined) {
        const adid = config.track.adid ? config.track.adid : '';
        const bid = config.track.bid ? config.track.bid :
          templateSearchParams.has(TPL_PARAMS.LICENSE_KEY) ? templateSearchParams.get(TPL_PARAMS.LICENSE_KEY) : '';
        const uid = config.track.uid ? config.track.uid :
          templateSearchParams.has(TPL_PARAMS.UID) ? templateSearchParams.get(TPL_PARAMS.UID) : '';
        const vpadnSid =
          templateSearchParams.has(TPL_PARAMS.SESSION_ID) ? templateSearchParams.get(TPL_PARAMS.SESSION_ID) : '';
        const vpadnSeq =
          templateSearchParams.has(TPL_PARAMS.SEQUENCE_ID) ? templateSearchParams.get(TPL_PARAMS.SEQUENCE_ID) : '';
        const clid = '1.' + bid + '.' + vpadnSid + '.' + vpadnSeq;
        const vid_tid = config.track.trackid ? config.track.trackid :
          templateSearchParams.has(TPL_PARAMS.VIDEO_TRACKING_ID) ?
            templateSearchParams.get(TPL_PARAMS.VIDEO_TRACKING_ID) : '';
        const e = config.track.e ? config.track.e : templateSearchParams.has(TPL_PARAMS.PARAM_E) ? templateSearchParams.get(TPL_PARAMS.PARAM_E) : '';
        let eventMapping;
        switch (event) {
          case 'start':
            eventMapping = '__vpad_a_start';
            break;
          case 'firstQuartile':
            eventMapping = '__vpad_a_firstquartile';
            break;
          case 'midpoint':
            eventMapping = '__vpad_a_midpoint';
            break;
          case 'thirdQuartile':
            eventMapping = '__vpad_a_thirdquartile';
            break;
          case 'complete':
            eventMapping = '__vpad_a_complete';
            break;
          case 'replay':
            eventMapping = '__vpad_a_replay';
            break;
          case 'link':
            eventMapping = '__vpad_a_link';
            break;
          case 'changemute':
            eventMapping = '__vpad_a_changemute';
            break;
          case 'progress':
            eventMapping = '__vpad_a_progress';
            break;
          case 'play':
            eventMapping = '__vpad_a_play';
            break;
          case 'pause':
            eventMapping = '__vpad_a_pause';
            break;
        }
        var videoEventUrl = new URL(VIDEO_EVENT_URL);
        var baseVideoEventParams = new URLSearchParams({
          t: 'event',
          tid: vid_tid,
          ec: '__vpad_c_vid',
          el: vid_tid,
          clid: clid,
          ad: adid,
          uid: uid,
          e: e
        });
        videoEventUrl.search = baseVideoEventParams;
        videoEventUrl.searchParams.append('ea', eventMapping);
        VponConsole('log', videoEventUrl.toString());
        return videoEventUrl.toString();
      } else {
        return "";
      }
    }

    var trackingUrl = {
      "start": [getVideoEventUrlByEvnt('start')],
      "firstQuartile": [getVideoEventUrlByEvnt('firstQuartile')],
      "midpoint": [getVideoEventUrlByEvnt('midpoint')],
      "thirdQuartile": [getVideoEventUrlByEvnt('thirdQuartile')],
      "complete": [getVideoEventUrlByEvnt('complete')],
      "replay": [getVideoEventUrlByEvnt('replay')],
      "link": [getVideoEventUrlByEvnt('link')],
      "changemute": [getVideoEventUrlByEvnt('changemute')],
      "progress": [getVideoEventUrlByEvnt('progress')],
      "play": [getVideoEventUrlByEvnt('play')],
      "pause": [getVideoEventUrlByEvnt('pause')]
    };

    function setTrackingTimes(videoTotalTime) {
      trackingTimesArray = []
      trackingTimes['start'] = {
        time: digitSet(Math.floor(videoTotalTime * (4 / 4))),
        tag: 'videoStart',
      }
      trackingTimesArray.push(trackingTimes['start'])
      trackingTimes['first'] = {
        time: digitSet(Math.floor(videoTotalTime * (3 / 4))),
        tag: 'videoFirst',
      }
      trackingTimesArray.push(trackingTimes['first'])
      trackingTimes['mid'] = {
        time: digitSet(Math.floor(videoTotalTime * (2 / 4))),
        tag: 'videoMid',
      }
      trackingTimesArray.push(trackingTimes['mid'])
      trackingTimes['third'] = {
        time: digitSet(Math.floor(videoTotalTime * (1 / 4))),
        tag: 'videoThird',
      }
      trackingTimesArray.push(trackingTimes['third'])
      trackingTimes['end'] = {
        time: digitSet(Math.floor(videoTotalTime * (0 / 4))),
        tag: 'videoEnd',
      }
      trackingTimesArray.push(trackingTimes['end'])
      let progress = config.track && config.track.progress ? config.track.progress : templateSearchParams.get(TPL_PARAMS.PROGRESS)
      if (progress && progressValidate(progress, videoTotalTime)) {
        trackingTimes['progress'] = {
          time: digitSet(progressValidate(progress, videoTotalTime)),
          tag: 'progress'
        }
        trackingTimesArray.push(trackingTimes['progress'])
      } else {
        trackingTimes['progress'] = {
          time: null,
          tag: 'progress'
        }
        VponConsole('warn', '[VponVideo] no have progress');
      }
    }

    /**
     * 驗證progress參數格式
     * @param {string} progress - 擷取progress參數
     * @param {number} videoTotalTime - 影片總長度(單位：秒)
     */
    function progressValidate(progress, videoTotalTime) {
      let time = null
      if (!progress) {
        return false
      }

      if (progress.indexOf('%') !== -1) {
        //格式為百分比
        if (isNaN(parseFloat(progress))) {
          return false
        }
        time = parseFloat(progress) < 0 ? String(videoTotalTime) : parseFloat(progress) > 100 ? '0' : String(videoTotalTime - (videoTotalTime * parseFloat(progress) / 100));
      } else {
        //格式為時：分：秒
        let progressTimeArr = progress.split(':');
        let progressTime = videoTotalTime - (parseFloat(progressTimeArr[0]) * 3600 + parseFloat(progressTimeArr[1]) * 60 + parseFloat(progressTimeArr[2]))
        if (isNaN(progressTime)) {
          return false
        }
        time = progressTime < 0 ? '0' : progressTime > videoTotalTime ? String(videoTotalTime) : String(progressTime);
      }
      return time
    }
    var MoatApiReference;
    if (window.support && typeof support.isInWeb === 'function' && support.isInWeb()) {
      this.initialMoat = function (ids, duration, partnerCode) {
        const video_area = typeof videoContainer === 'string' ? document.querySelector(`#${videoContainer}`) : videoContainer;
        const c = video_area
        const l = config.src
        MoatApiReference = initMoatTracking(ids, duration, partnerCode)
        function initMoatTracking(d, e, k) { var g = document.createElement("script"), a = []; d = { adData: { ids: d, duration: e, url: l }, dispatchEvent: function (b) { this.sendEvent ? (a && (a.push(b), b = a, a = !1), this.sendEvent(b)) : a.push(b) } }; e = "_moatApi" + Math.floor(1E8 * Math.random()); var f, h; try { f = c.ownerDocument, h = f.defaultView || f.parentWindow } catch (b) { f = document, h = window } h[e] = d; g.type = "text/javascript"; c && c.insertBefore(g, c.childNodes[0] || null); g.src = "https://z.moatads.com/" + k + "/moatvideo.js#" + e; return d };
      }
    }
    
    function triggerMoatEvent(eventType) {
      var adVolume = Math.floor(video.volume)
      if (video.muted === true) {
        adVolume = 0
      }
      var videoEvent = {
        type: eventType,
        adVolume: adVolume
      }
      if (MoatApiReference === undefined) {
        return
      }
      MoatApiReference.dispatchEvent(videoEvent)
    }

    // 在 OM SDK 架構下，打出 Impression, start, firstQuartile... 等等四分位報表時的 callback，告知 Native 已經打出 Tracking
    function fireOMEventOccur(deviceType, eventType, sessionId) {
      switch (deviceType) {
        case 'a':
          _vpon_android.omEventOccur(JSON.stringify({
            eventType,
            sessionId
          }))
          break;
        case 'i':
          window.webkit.messageHandlers.omEventOccur.postMessage(JSON.stringify({
            eventType,
            sessionId
          }));
          break;
        default:
          VponConsole('log', '[VponVideo] Can not parse arguments of device type.');
      }
    }

    const viewableDetectionListener = () => {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: [0.5, 1]
      }
      const callback = entries => {
        entries.forEach(entry => {
          const viewPercent = parseInt(entry.intersectionRatio * 100)
          for (let listener of listeners) {
            listener(viewPercent);
          }
        })
        listenDOM.unobserve(document.querySelector('body'));
      }
      const listenDOM = new IntersectionObserver(callback, options)
      listenDOM.observe(document.querySelector('body'))
    }

    function sendVideoTracking(eventsLister, videoLeftTime) {
      let stateArr = checkVideoTimeState(videoLeftTime)

      stateArr.forEach(item => {
        if (isSendTrackingEventArr.indexOf(item) === -1) {
          isSendTrackingEventArr.push(item)
          switch (item) {
            case 'videoStart':
              var muted = video.muted ? 0 : 1
              if (config.track && Object.keys(config.track).length !== 0) {
                sendQuartileTracking(trackingUrl.start)
              }
              customTracking(eventsLister, 'quartileTracking', 0)
              triggerMoatEvent('AdVideoStart')
              try {
                viewableDetectionListener()
                if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                  VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.start & vponOMIDBridge.adEvents.impressionOccurred()');
                  window.vponOMIDBridge.videoEvents.start(video.duration, muted);
                  window.vponOMIDBridge.adEvents.impressionOccurred();
                  if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                    VponConsole('warm', '[VponVideo] fire omEventOccur.');
                    fireOMEventOccur(vponOMIDBridge.deviceType, 'impression', vponOMIDBridge.sessionId)
                    fireOMEventOccur(vponOMIDBridge.deviceType, 'start', vponOMIDBridge.sessionId)
                  }
                }
              } catch (error) { VponConsole('warn', error) }
              break
            case 'videoFirst':
              if (config.track && Object.keys(config.track).length !== 0) {
                sendQuartileTracking(trackingUrl.firstQuartile)
              }
              customTracking(eventsLister, 'quartileTracking', 1)
              triggerMoatEvent('AdVideoFirstQuartile')
              try {
                if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                  VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.firstQuartile()');
                  window.vponOMIDBridge.videoEvents.firstQuartile();
                  if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                    VponConsole('warn', '[VponVideo] fire omEventOccur.');
                    fireOMEventOccur(vponOMIDBridge.deviceType, 'firstQuartile', vponOMIDBridge.sessionId)
                  }
                }
    
              } catch (error) { VponConsole('warn', error) }
              break
            case 'videoMid':
              if (config.track && Object.keys(config.track).length !== 0) {
                sendQuartileTracking(trackingUrl.midpoint)
              }
              customTracking(eventsLister, 'quartileTracking', 2)
              triggerMoatEvent('AdVideoMidpoint')
              try {
                if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                  VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.midpoint()');
                  window.vponOMIDBridge.videoEvents.midpoint();
                  if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                    VponConsole('warn', '[VponVideo] fire omEventOccur.');
                    fireOMEventOccur(vponOMIDBridge.deviceType, 'midpoint', vponOMIDBridge.sessionId)
                  }
                }
              } catch (error) { VponConsole('warn', error) }
              break
            case 'videoThird':
              if (config.track && Object.keys(config.track).length !== 0) {
                sendQuartileTracking(trackingUrl.thirdQuartile)
              }
              customTracking(eventsLister, 'quartileTracking', 3)
              triggerMoatEvent('AdVideoThirdQuartile')
              try {
                if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                  VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.thirdQuartile()');
                  window.vponOMIDBridge.videoEvents.thirdQuartile();
                  if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                    VponConsole('warn', '[VponVideo] fire omEventOccur.');
                    fireOMEventOccur(vponOMIDBridge.deviceType, 'thirdQuartile', vponOMIDBridge.sessionId)
                  }
                }
              } catch (error) { VponConsole('warn', error) }
              break
            case 'videoEnd':
              if (config.track && Object.keys(config.track).length !== 0) {
                sendQuartileTracking(trackingUrl.complete)
              }
              customTracking(eventsLister, 'quartileTracking', 4)
              triggerMoatEvent('AdVideoComplete')
              try {
                if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                  VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.complete()');
                  window.vponOMIDBridge.videoEvents.complete();
                  if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                    VponConsole('warn', '[VponVideo] fire omEventOccur.');
                    fireOMEventOccur(vponOMIDBridge.deviceType, 'complete', vponOMIDBridge.sessionId)
                  }
                }
              } catch (error) { VponConsole('warn', error) }
              break
            case 'progress':
              if (config.track && Object.keys(config.track).length !== 0) {
                sendQuartileTracking(trackingUrl.progress)
              }
              break
            case 'play':
              eventMapping = '__vpad_a_play';
              break;
      
            case 'pause':
              eventMapping = '__vpad_a_pause';
              break;
          }
        }
      })
    }

    function checkVideoTimeState(videoLeftTime) {
      let stateArr = [];
      if (Object.keys(trackingTimes).length === 0) {
        return;
      }
      if (videoLeftTime == trackingTimes['start'].time) {
        stateArr.push(trackingTimes['start'].tag)
      }
      
      if (videoLeftTime == trackingTimes['first'].time) {
        stateArr.push(trackingTimes['first'].tag)
      }

      if (videoLeftTime == trackingTimes['mid'].time) {
        stateArr.push(trackingTimes['mid'].tag)
      } 

      if (videoLeftTime == trackingTimes['third'].time) {
        stateArr.push(trackingTimes['third'].tag)
      } 

      if (videoLeftTime == trackingTimes['end'].time) {
        stateArr.push(trackingTimes['end'].tag)
      }
      
      if (videoLeftTime == trackingTimes['progress'].time) {
        stateArr.push(trackingTimes['progress'].tag)
      }

      return stateArr;
    }

    const handleTimeUpdate = (function () {
      let currentTime
      return function () {
        if (video.currentTime === 0 || video.duration === NaN) {
          return;
        }
        const videoLeftTime = video.duration - video.currentTime
        if (isDifferentTime(currentTime)) {
          updateCountdown(videoLeftTime)
          setVponVideoControls()
          let stateArr = checkVideoTimeState(videoLeftTime)
          if (stateArr.indexOf('videoStart') !== -1) {
          } else if (stateArr.indexOf('videoEnd') !== -1) {
            isPlaying = false
            video.currentTime = video.duration
            showVponVideoReplayControls()
          }
        }
        currentTime = videoLeftTime
      }
    })()
    function isDifferentTime(curr) {
      return (curr !== Math.floor(video.duration - video.currentTime)) ? true : false
    }

    function customCreateElement(dom, id) {
      var customDOM = document.createElement(dom)
      customDOM.setAttribute('id', id)
      return customDOM
    }

    var videoTimeSpan = customCreateElement('span', 'countdownTime')
    videoTimeSpan.setAttribute('id', 'countdownTime')
    videoTimeSpan.style.position = 'absolute'
    videoTimeSpan.style[config.countdownPosition === 'top' ? 'top' : 'bottom'] = '15px'
    videoTimeSpan.style.left = '15px'
    videoTimeSpan.style.fontSize = '17px'
    videoTimeSpan.style.color = '#fff'
    videoTimeSpan.style.display = config.countdownHidden ? 'none' : 'block'

    function updateCountdown(videoLeftTime) {
      video.parentElement.appendChild(videoTimeSpan)
      var countdownTime = document.querySelector('#countdownTime')
      if (document.querySelector('iframe[class^="Vpon__flrec"]')) {
        countdownTime = document.querySelector('iframe[class^="Vpon__flrec"]').contentDocument.querySelector('#countdownTime');
      }
      var min = digitSet(Math.floor(videoLeftTime / 60))
      var sec = digitSet(Math.floor(videoLeftTime % 60))
      if (isNaN(min) || isNaN(sec)) {
        return;
      }
      countdownTime.innerText = min + ":" + sec
    }

    var replayButton = customCreateElement('img', 'replayButton')
    replayButton.style.zIndex = 2;
    replayButton.setAttribute('aria-label', systemVar.ariaLabel.replay_button)
    var otherLink = customCreateElement('span', 'otherLink')

    function setVponVideoControls() {
      var replayIcon = 'data:image/png;base64,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'
      replayButton.src = replayIcon
      replayButton.style.position = 'absolute'
      replayButton.style.top = '50%'
      replayButton.style.left = '50%'
      replayButton.style.transform = 'translate(-50%, -50%)'
      replayButton.style.width = '60px'
      replayButton.style.display = 'none'
      video.parentElement.appendChild(replayButton)
      replayButton.addEventListener('click', replayVideo)
      otherLink.style.position = 'absolute'
      otherLink.style.color = '#fff'
      otherLink.style.fontSize = '17px'
      otherLink.style.top = '15px'
      otherLink.style.right = '15px'
      otherLink.innerText = templateSearchParams.has(TPL_PARAMS.VIDEO_FUNCTION_1_DESC) ? templateSearchParams.get(TPL_PARAMS.VIDEO_FUNCTION_1_DESC) : ''
      otherLink.style.display = 'none'
      video.parentElement.appendChild(otherLink)
      otherLink.addEventListener('click', openOtherLink)
    }

    function showVponVideoReplayControls() {
      replayButton.style.display = "block"
      otherLink.style.display = "block"
    }

    function replayVideo(e) {
      e.stopPropagation()
      if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
        VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.resume()');
        window.vponOMIDBridge.videoEvents.resume();
        if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
          VponConsole('warn', '[VponVideo] fire omEventOccur.');
          fireOMEventOccur(vponOMIDBridge.deviceType, 'resume', vponOMIDBridge.sessionId)
        }
      }
      video.currentTime = 0;
      replayButton.style.display = "none";
      video.play();
    }
    function openOtherLink(e) {
      let clickUrl = templateSearchParams.get(TPL_PARAMS.W_F_1_A);
      clickUrl = clickUrl.replace(/\[.*?\]/g, -1);

      if (e) {
        clickUrl = clickUrl.replace('clk_x=-1&clk_y=-1', `clk_x=${e.clientX}&clk_y=${e.clientY}`);
      }

      if (window.support) {
        if (e) {
          support.click(e);
        } else {
          support.click();
        }
        support.open(clickUrl);
      }
    }

    video.addEventListener('playing', (function () {
      var executed = false
      return function () {
        if (!executed) {
          setTrackingTimes(Math.floor(video.duration))
          executed = true
          isPlaying = true
        }
      }
    })(), false);
    video.addEventListener('timeupdate', handleTimeUpdateFunc);
    video.addEventListener('volumechange', e => {
      try {
        VponConsole('log', '[VponVideo] in volume change listener, ready to fire event');
        if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
          VponConsole('log', '[VponVideo] fire volumechange event');
          const muted = video.muted ? 0 : 1
          window.vponOMIDBridge.videoEvents.volumeChange(muted)
        }
      } catch (error) { VponConsole('warn', error) }
    })
  }
}

window.VponVideo = VponVideo;


// WEBPACK FOOTER //
// ./src/vpon-video/vpadn-video-sdk.js